import { fork } from 'redux-saga/effects';

import { actions, selectors } from 'domain/scrapped';
import { listNavigator } from 'sagas/common';
import filters from 'filters/scrapped';

export default function* navigator() {
  yield fork(listNavigator, { modelName: 'Scrapped', actions, selectors, filters } );
}
